import { render } from "./ShippingDetails.vue?vue&type=template&id=1076588c&scoped=true"
import script from "./ShippingDetails.vue?vue&type=script&lang=js"
export * from "./ShippingDetails.vue?vue&type=script&lang=js"

import "./ShippingDetails.vue?vue&type=style&index=0&id=1076588c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1076588c"]])

export default __exports__